import React, { VFC } from 'react'

import { AppUsers } from 'features/users/AppUsers/AppUsers'
import { SlidingPaneFrame } from 'features/workspace/AdminSideTray/common/SlidingPaneFrame'

type ManageUsersSidePaneProps = {}
export const ManageUsersSidePane: VFC<ManageUsersSidePaneProps> = () => {
    return (
        <SlidingPaneFrame title="Manage users" description="Manage who has access to this app.">
            <AppUsers />
        </SlidingPaneFrame>
    )
}
